import React from 'react';
import useTitle from '../../Hooks/useTitle';

const About = () => {
    useTitle('About');
    return (
        <div>
            <h1>about</h1>
        </div>
    );
};

export default About;